export default {
    LeadStatus: {
        getdata: []
    }
};